import { DeliveryRegistrationFormUi } from '@/components/Order/OrderDetails/DeliveryRegistrationForm/DeliveryRegistrationFormUi';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { updateOrderDeliveryInfo } from '@/data/api/request/orderDetailsRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deliveryRegistrationFormUiToOrderDeliveryInfoRequest } from './mapper';

export function useUpdateOrderDeliveryInfo() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: {
      orderId: string;
      payload: DeliveryRegistrationFormUi;
    }) => {
      const payload = deliveryRegistrationFormUiToOrderDeliveryInfoRequest(
        args.payload
      );
      await updateOrderDeliveryInfo(args.orderId, payload);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.detailOrder.deliveryInfo, variables.orderId],
      });
      showSnackSuccess('Información de entrega actualizada');
    },
    onError: () =>
      showSnackError('Error al actualizar la información de entrega'),
  });

  return { updateOrderDeliveryInfo: mutation.mutate };
}
